import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionTitle from "@/components/feature/SectionTitle";
import { articles } from "@/mocks/articles";
import type { Article } from "@/types/content";

const FocusSection = () => {
  const featured = articles.filter((item) => item.featured) as Article[];
  const main = featured.find((item) => item.id === "zongyi-2013-live-accident") || featured[0];
  const grid = articles.filter((item) => item.id !== main?.id).slice(0, 4);
  const rows = grid.slice(0, 3);
  const fourth = grid[3];

  return (
    <section className="bg-background-50 paper-grain">
      <div className="mx-auto max-w-shell px-4 py-14 md:px-6 md:py-20">
        <SectionTitle
          eyebrow="本期聚焦"
          title="这几条旧料，最近又被翻了出来"
          desc="按时间顺序重新核对过的新条目，每一条都附上了大致年份和可查证的出处。"
          linkTo="/archive"
          linkLabel="查看全部合集"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">{main && <ArticleCard article={main} variant="feature" />}</div>

          <div className="flex flex-col lg:col-span-5">
            <div className="flex flex-col gap-5">
              {rows.map((article) => (
                <ArticleCard key={article.id} article={article} variant="row" />
              ))}
            </div>

            {fourth && (
              <div className="mt-6 rounded-lg border border-foreground-950/10 bg-accent-100/70 p-5">
                <p className="font-label text-xs tracking-[0.22em] text-accent-800">本周待整理</p>
                <h3 className="mt-3">
                  <Link
                    to={`/article/${fourth.id}`}
                    className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors hover:text-primary-600"
                  >
                    {fourth.title}
                  </Link>
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{fourth.excerpt}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FocusSection;